<template>
    <a
        :class="['podium-card', darkMode ? 'dark' : '']"
        :aria-label="partner.partner_name"
        :href="clickOutUrl(partner, index)"
        @clicked="clickoutEvent(partner, index)"
        target="_blank"
    >
        <div
            class="container"
            :style="{ borderColor: index === 0 ? borderColor : '#eee' }"
        >
            <DefaultFlag v-if="index === 0" v-bind="flagProps" />
            <BaseImage
                loadLazy
                class="image"
                :alt="partner.partner_name"
                :img-source="partner.logo_image"
                width="200px"
                height="100px"
                :style="{ height: 'auto', width: '100px' }"
                quality="80"
            />

            <div class="info">
                <div class="score" :style="scoreStyles">
                    {{ formatScore(partner.score) }}
                    <Rating v-bind="ratingProps"></Rating>
                </div>
                {{
                    partner.marketing_properties.podium_pro_short_discount ||
                    partner.marketing_properties.members
                }}
            </div>

            <CtaButton
                is-active
                class="button"
                :aria-label="partner.partner_name"
                :clickout-link="clickOutUrl(partner, index)"
                v-bind="buttonProps"
                @clicked="clickoutEvent(partner, index)"
            >
                {{ $t('Visit Site') }}
            </CtaButton>
        </div>
    </a>
</template>
<script>
import DefaultFlag from '@atoms/Flag/DefaultFlag.vue';
import { COT_PODIUM, scoreTypes } from '@/constants';
import { analyticsMixin, clickOutMixin } from '@/mixins';
import { PodiumProProps } from '@molecules/PodiumPro/PodiumPro.props';
export default {
    name: 'PodiumCard',
    mixins: [analyticsMixin, clickOutMixin],
    components: {
        DefaultFlag,
    },
    props: {
        ...PodiumProProps,
        partner: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
        },
    },
    computed: {
        flagProps() {
            return {
                flagText: 'Most Popular',
                fill: this.flagColor,
                index: 0,
                flagTail: 'rounded',
                offsetTop: '0',
            };
        },
        ratingProps() {
            return {
                height: this.ratingIconSize,
                width: this.ratingIconSize,
                activeColor: this.ratingIconColor,
                inactiveColor: this.ratingIconInactiveColor,
                activeIcon: this.ratingIconType,
                rating: this.partner.score,
            };
        },
        scoreStyles() {
            return {
                fontSize: this.scoreTextSize,
            };
        },
        buttonProps() {
            return {
                shape: this.buttonShape,
                buttonType: this.buttonType,
                fill: this.buttonColor,
                textColor: this.buttonTextColor,
            };
        },
    },
    methods: {
        formatScore(score) {
            if (
                Boolean(score) &&
                score.toString().length < 2 &&
                this.scoreType === scoreTypes.number
            ) {
                score = score + '.0';
                return score;
            }
            return score;
        },
        clickoutEvent(partner, index) {
            this.clickout(
                this.categoryState.category.name,
                partner.clicked_partner_name,
                index,
                'podium_pro'
            );
        },
        clickOutUrl(partner, index) {
            return this.goto(partner.cp_id, index + 1, COT_PODIUM);
        },
    },
};
</script>

<style lang="scss" scoped>
.podium-card {
    position: relative;
    display: flex;
    height: fit-content;

    &:hover .container {
        transform: translateY(-12px);
    }

    &:first-of-type .container {
        padding: 30px 12px 20px;

        .image {
            max-height: 50px;
        }
    }

    .container {
        display: grid;
        grid-template-columns: 0.6fr 1fr;
        gap: 10px 20px;
        border: 2px solid #eee;
        border-radius: 8px;
        width: 100%;
        padding: 12px;
        background: #fff;
        align-items: center;
        transition: transform 0.3s ease-out;
        will-change: transform;
    }

    .image {
        grid-column: 1;
        grid-row: 1;
        width: 100% !important;
        object-fit: contain;
        max-height: 40px;
    }

    .score {
        grid-column: 1;
        grid-row: 2;
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: bold;
    }

    .info {
        grid-column: 2;
        grid-row: 1;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.4;
        color: #595959;
        line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .button {
        grid-column: 2;
        grid-row: 2;
        font-size: 14px;
    }

    ::v-deep .cta-button {
        span {
            line-height: 26px;
        }
    }

    ::v-deep .default-flag {
        box-shadow: 4px 4px 14px rgba(70, 69, 70, 0.25);
        top: -16px;
        left: -8px;
        border-radius: 16px;

        .flag.__rounded {
            border-radius: 16px;
        }
        .flag-text {
            font-size: 14px;
            font-weight: bold;
        }
    }
}

.podium-card.dark {
    .container {
        background: #1a1a1a;
        border-color: #1a1a1a;
    }

    .info,
    .score {
        color: #fff;
    }
}
</style>
